"use client";

import { Box, Chip, Typography } from "@mui/material";
import { useSiteSearchContext } from "./SiteSearchContext";

export default function MobileSearchedTextChip() {
  const { search, handleSearchChange } = useSiteSearchContext();
  if (!search) {
    return <></>;
  }
  return (
    <>
      <Chip
        variant={Boolean(search) ? "filled" : "outlined"}
        onClick={() => {
          handleSearchChange("");
        }}
        {...(Boolean(search) && {
          color: "primary",
          onDelete: () => {
            handleSearchChange("");
          },
        })}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2">
              جستجو
              {search && <strong> "{search}"</strong>}
            </Typography>
          </Box>
        }
      ></Chip>
    </>
  );
}
